import styled from 'styled-components';
import { pxToRem } from '@leaftrade/leaftrade-component-library';

export const CartLineItemColumnItemBatchQueuesVariantWrapper = styled.div`
  width: 40%;
  flex-grow: 1;
  padding-left: ${pxToRem(80)};
`;
